import React, { useState } from "react";
import "./FaqSection.css";

const faqCategories = [
  {
    category: "📌 Partnership & Service FAQs",
    faqs: [
      {
        question: "What does your company do exactly?",
        answer:
          "We help foreign companies sell their products in the Indian market without them needing to set up operations in India. We handle shipping, packaging, warehousing, returns, payments, and taxation — end-to-end fulfillment.",
      },
      {
        question: "Do I need to set up a company in India to work with you?",
        answer:
          "No. You don’t need a local office or legal entity. We act as your local partner, managing compliance and operations.",
      },
      {
        question: "Which product categories can you work with?",
        answer:
          "We work with most product categories, including fashion, health, beauty, food, electronics, and home goods. However, regulated items (like alcohol, tobacco, medical devices, etc.) require additional compliance checks.",
      },
      {
        question: "Can you help with Indian market compliance and certifications?",
        answer:
          "Yes. We guide you through mandatory certifications, labeling requirements, and import regulations.",
      },
    ],
  },
  {
    category: "💰 Pricing & Payment FAQs",
    faqs: [
      {
        question: "How does the 6-month free Basic Plan work?",
        answer:
          "You get 6 months of full-service fulfillment at no cost. After 6 months, the plan is $49/month unless you cancel.",
      },
      {
        question: "Are there any hidden fees in the Basic Plan?",
        answer:
          "No hidden fees. The only costs are:\n• Import duties, customs clearance charges, and transportation from your country to our Indian warehouse (paid by you)\n• Product-specific compliance costs, if applicable",
      },
      {
        question: "How will I receive my sales revenue from India?",
        answer:
          "We handle payment collection in India and transfer your sales revenue to your bank account in USD (or your preferred currency) after deducting applicable service fees.",
      },
    ],
  },
  {
    category: "📦 Operations & Fulfillment FAQs",
    faqs: [
      {
        question: "How do you handle shipping from my country to India?",
        answer:
          "You can arrange shipping yourself, or we can recommend freight forwarders. Import duties, transportation, and customs charges are paid by you until your products reach our warehouse.",
      },
      {
        question: "What happens when my shipment arrives at your warehouse?",
        answer:
          "When your products arrive, we record a video of the package opening so you have proof of their condition on arrival. This ensures transparency and helps you claim any transport-related damage with your logistics provider.",
      },
      {
        question: "Is my stock safe in your warehouse?",
        answer:
          "Yes. Your products are stored in a secure facility with 24-hour CCTV surveillance. If any damage or loss happens while products are in our care, we take full responsibility.",
      },
      {
        question: "Can you help with marketplace selling like Amazon India or Flipkart?",
        answer:
          "Yes, this is included in the Standard Plan (after upgrade approval).",
      },
      {
        question: "Do I need to handle customer service in India?",
        answer:
          "No, we manage customer service for all orders within India.",
      },
    ],
  },
  {
    category: "📈 Guaranteed Sales Plans FAQs",
    faqs: [
      {
        question: "Can I choose to upgrade to a Guaranteed Sales Plan anytime?",
        answer:
          "No. Upgrade is invitation-only based on a performance review during your Basic Plan trial. If your product qualifies, we’ll offer you the upgrade.",
      },
      {
        question: "What is included in the $999/month Standard Plan?",
        answer:
          "• Everything in Basic Plan\n• Marketplace Setup (Amazon, Flipkart, etc.)\n• Product Audit & Review\n• Custom Marketing Strategy\n• Dedicated Support\n• $1M annual sales guarantee",
      },
      {
        question: "What is included in the $9999/month Premium Plan?",
        answer:
          "• Everything in Standard Plan\n• Retail Market Setup (DMart, Reliance Smart)\n• Franchise Distribution Support\n• Dedicated Account Manager\n• Priority Support\n• $10M annual sales guarantee",
      },
      {
        question: "What happens if the guaranteed sales target isn’t reached?",
        answer:
          "We work free until the promised sales figure is achieved.",
      },
    ],
  },
  {
    category: "🛡️ Trust & Safety FAQs",
    faqs: [
      {
        question: "How do I know my brand is safe with you?",
        answer:
          "We sign a formal agreement covering confidentiality, intellectual property rights, and clear commercial terms before starting.",
      },
      {
        question: "How do you ensure my product is marketed correctly?",
        answer:
          "Our team studies your brand, adapts messaging for Indian audiences, and works with you on marketing approvals.",
      },
      {
        question: "Can you help if my product needs rebranding or packaging changes for India?",
        answer:
          "Yes, we offer packaging localization and branding assistance.",
      },
      {
        question: "What happens if my product doesn’t sell well in India?",
        answer:
          "If performance is weak during the Basic Plan, you can either continue at $49/month, pause operations, or adjust strategy.",
      },
    ],
  },
];

const FaqPage = () => {
  const [openIndex, setOpenIndex] = useState({ cat: null, faq: null });

  const toggleFaq = (catIndex, faqIndex) => {
    if (openIndex.cat === catIndex && openIndex.faq === faqIndex) {
      setOpenIndex({ cat: null, faq: null });
    } else {
      setOpenIndex({ cat: catIndex, faq: faqIndex });
    }
  };

  return (
    <>
      <section className="faq-header">
        <h1>Frequently Asked Questions</h1>
        <p>Your Gateway to the Indian Market – Risk-Free Entry, Guaranteed Growth</p>
      </section>

      <section className="faq-body">
        <div className="faq-wrapper">
          {faqCategories.map((cat, catIndex) => (
            <div key={catIndex} className="faq-category">
              <h2>{cat.category}</h2>
              {cat.faqs.map((item, faqIndex) => (
                <div
                  className="faq-card"
                  key={faqIndex}
                  onClick={() => toggleFaq(catIndex, faqIndex)}
                >
                  <div className="faq-question">
                    {item.question}
                    <span className="icon">
                      {openIndex.cat === catIndex && openIndex.faq === faqIndex ? "▲" : "▼"}
                    </span>
                  </div>
                  {openIndex.cat === catIndex && openIndex.faq === faqIndex && (
                    <div className="faq-answer">
                      {item.answer.split("\n").map((line, i) => (
                        <p key={i}>{line}</p>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default FaqPage;
